import { WaringMessage } from './InputWarningMessage.styled';

const InputWarningMessage: React.FC<{ message: string }> = ({ message }) => {
    return <WaringMessage>{message}</WaringMessage>;
};

export default InputWarningMessage;
